/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */

import { HealthSurveillanceQuestionConfig, MedicalTypeId, MedicalTypeIds } from "../models";

import * as questionIds from "./questionIds";

const AmzPitPupMedicals: MedicalTypeId[] = [
    MedicalTypeIds.AmzPitPupMedical,
    MedicalTypeIds.AmzPitPupHealthDeclaration
];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../questionnaire";` which is in a data structure suitable for use with custom medicals
 */
const section14Questions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.UnderstandCompleteAnnualSelfDeclarationToContinueWorkingAsPitPupDriver,
        questionText: "I understand that I must complete an annual medical self-declaration form in order to continue working as a PIT/PUP Driver and that failure to complete this declaration may result in removal of permissions for me to perform the role of PIT/PUP Driver.*",
        medicalTypes: AmzPitPupMedicals
    },
    {
        id: questionIds.IfAnsweredYesToAnyQuestionsAreSymptomsOngoingForLongerThan12Months,
        questionText: "If you have answered yes to any of the medical questions please confirm if any symptoms, diagnosis or treatments (including medication) have been ongoing for 12 months or longer",
        medicalTypes: AmzPitPupMedicals
    },
    {
        id: questionIds.ConfirmThereHasBeenNoChangeToVisionOrOngoingMedicalConditionSinceLastF2FPitPupAssessment,
        questionText: "Can you confirm that there has been no change to your vision or the ongoing medical condition, symptoms or to your treatment (including medication) since your last Face to Face PIT/PUP assessment?",
        medicalTypes: AmzPitPupMedicals
    },
    {
        id: questionIds.AreAnySymptomsOrMedicationNewWithinLast12Months,
        questionText: "Are any of your symptoms, diagnosis or medication new within the last 12 months?",
        medicalTypes: AmzPitPupMedicals
    },
    {
        id: questionIds.PitPupMedicalsFurtherDetails,
        questionText: "Further Details",
        medicalTypes: AmzPitPupMedicals
    },
    {
        id: questionIds.UnderstandFailureToDiscloseInformationMayResultInTerminationOfContractOfEmployment,
        questionText: "I understand that if I fail to disclose information or make a false statement that this may lead to the termination of my contract of employment.*",
        medicalTypes: AmzPitPupMedicals
    }
];

export { section14Questions };
